module.exports = __webpack_public_path__ + "media/ANGOLI-DEFINITIVI_720.7f907800.mp4";